import {  useState } from "react";

import { useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { updateBouns } from "../../../../../MyApi/hr/bouns";

import icons from "../../../../../Data/icons";

import classes from "./attachModal.module.css";


const BounsModal = ({ closeModal, rowId, bounses }) => {
  const { t } = useTranslation();


  const CloseIcon = icons.close;
  const PaidIcon = icons.paid;
  const UserIcon = icons.user;
  const DateIcon = icons.date;;
  const StatusIcon = icons.status;
  const AmountIcon = icons.amount
  const AbcIcon = icons.abc
  const bounsShow =
  bounses.find((bouns) => bouns.id === rowId) || {};
  const {
    id,
    employe,
    name,
    paid,
    date,
    issue_date,
    paid_date,
    amount_type,
    amount,
    status,
  } = bounsShow;
  const [paidState, setPaid] = useState(paid);
  const [statusState, setStatus] = useState(status);
  const [PaidDateState, setPaidDate] = useState(paid_date);



  const mutation = useMutation(
    ["updateBouns", id],
    (postData) => updateBouns(postData, id),
    {
      onSuccess: (data) => {
        toast.success(`${data.message}`);
        closeModal();
      },
      onError: (error) => {
        toast.error(`${error.response.data.message}`);
      },
    }
  );

  const handelPostRequest = () => {
    mutation.mutate({
      paid: paidState,
      paid_date: PaidDateState,
      status: statusState,
    });
  };
  const handelChangePaid = (e) => {
    const isChecked = e.target.checked;
    const newState = isChecked ? 1 : 0;
    setPaid(newState);
  };
  const handelStatusChange = (e) => {
    const { value } = e.target;
    setStatus(value);
  };
  const handelPaidDate = (e) => {
    const { value } = e.target;
    setPaidDate(value);
  };
  const statues = ["paid", "approved", "canceled", "deserved", "pending"];

  return (
    <div className={classes.modalOverLay}>
      <div className={classes.modalCard}>
        <div className={classes.modalHeader}>
          <button className={classes.modalCloseBtn} onClick={closeModal}>
            <CloseIcon />
          </button>
          <h2 className={classes.modalTitle}>تفاصيل المكافئات</h2>
        </div>
        <div className={classes.modalBody}>
          <div className="row">
            <div className="col-lg-6">
              {" "}
              <div class="user-profile">
                <div class="post-about card-body">
                  <div className="row">
                    <div className="col-lg-6">
                      <ul class="list-group">
                        <li class="list-group-item">
                          <div class="icon">
                            <AbcIcon />
                          </div>
                          <div>
                            <h5 className="mb-1">#</h5>
                            <p>{id}</p>
                          </div>
                        </li>
                        <li class="list-group-item">
                          <div class="icon">
                            <AbcIcon />
                          </div>
                          <div>
                            <h5 className="mb-1">{t("Name")}</h5>
                            <p>{name}</p>
                          </div>
                        </li>
                        <li class="list-group-item">
                          <div class="icon">
                            <UserIcon />
                          </div>
                          <div>
                            <h5 className="mb-1">الموظف</h5>
                            <p>{employe}</p>
                          </div>
                        </li>
                        <li class="list-group-item">
                          <div class="icon">
                            <DateIcon />
                          </div>
                          <div>
                            <h5 className="mb-1">{t("issue_date")}</h5>
                            <p>{issue_date}</p>
                          </div>
                        </li>
                        <li class="list-group-item">
                          <div class="icon">
                            <DateIcon />
                          </div>
                          <div>
                            <h5 className="mb-1">{t("date")}</h5>
                            <p>{date}</p>
                          </div>
                        </li>
                        <li class="list-group-item">
                          <div class="icon">
                            <AmountIcon />
                          </div>
                          <div>
                            <h5 className="mb-1">{t("amount")}</h5>
                            <p>{amount}</p>
                          </div>
                        </li>
                        <li class="list-group-item">
                          <div class="icon">
                            <AmountIcon />
                          </div>
                          <div>
                            <h5 className="mb-1">{t("amount_type")}</h5>
                            <p>{amount_type}</p>
                          </div>
                        </li>
                        {paid ===1 && <li class="list-group-item">
                          <div class="icon">
                            <DateIcon />
                          </div>
                          <div>
                            <h5 className="mb-1">{t("paid_date")}</h5>
                            <input
                              type="date"
                              className="form-control"
                              value={PaidDateState}
                              onChange={handelPaidDate}
                            />
                          </div>
                        </li>}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div class="user-profile">
                <div class="post-about card-body">
                  <div className="row">
                    <div className="col-lg-6">
                      <ul class="list-group">
                        <li class="list-group-item">
                          <div class="icon">
                            <PaidIcon />
                          </div>
                          <div>
                            <h5 className="mb-1">{t("paid")}</h5>
                            <div>
                              <label class="switch">
                                <input
                                  type="checkbox"
                                  onChange={handelChangePaid}
                                  checked={paidState}
                                />
                                <span class="slider round"></span>
                              </label>
                            </div>
                          </div>
                        </li>
                        <li class="list-group-item">
                          <div class="icon">
                            <StatusIcon />
                          </div>
                          <div>
                            <h5 className="mb-1">{t("Status")}</h5>
                            <div>
                              <select
                                onChange={handelStatusChange}
                                className="form-select">
                                {statues.map((statu, i) => (
                                  <option key={i} selected={statu===statusState}>
                                    {statu}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.modalFooter}>
          <button className="btn btn-primary" onClick={handelPostRequest}>
            حفظ
          </button>
        </div>
      </div>
    </div>
  );
};

export default BounsModal;
